import { Injectable, computed, inject } from '@angular/core';
import { AuthService } from './auth.service';
import { RoleEnum } from '@/app/consts/role.const';
import { LabelService } from './label.service';

@Injectable({
  providedIn: 'root'
})
export class RoleSwitcherService {
  private authService = inject(AuthService);
  private labelService = inject(LabelService);

  // Computed signals for role management
  availableRoles = computed(() => this.authService.availableRoles());
  selectedRole = computed(() => this.authService.selectedRole());
  hasMultipleRoles = computed(() => this.availableRoles().length > 1);
  currentRoleLabel = computed(() => this.getRoleLabel(this.selectedRole()));

  // Methods
  onRoleChange(role: RoleEnum): void {
    this.authService.setSelectedRole(role);
  }

  private getRoleLabel(role: RoleEnum | null | string): string {
    if (!role || role === '') return 'Unknown';
    return this.labelService.getRoleLabel(role as RoleEnum) || 'Unknown';
  }
}